import { render, staticRenderFns } from "./AlertaBasePantalla.vue?vue&type=template&id=481f7042&"
import script from "./AlertaBasePantalla.vue?vue&type=script&lang=ts&"
export * from "./AlertaBasePantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('481f7042', component.options)
    } else {
      api.reload('481f7042', component.options)
    }
    module.hot.accept("./AlertaBasePantalla.vue?vue&type=template&id=481f7042&", function () {
      api.rerender('481f7042', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ConfigurarBase/AlertaBasePantalla.vue"
export default component.exports